/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useEffect, useRef, useState,useContext } from 'react';
import AnimatedModel from '../../../../components/Animation/AnimatedModel';
import UpdateButton from '../../../../components/UpdateButton';
import { userService } from '../../../../services/user.services';
import { useNavigate } from 'react-router-dom';
import GlobalContext from '../../../../components/Context/GloablContext';
import CustomOverLay from '../../../../components/CustomOverLay';
import { useDispatch } from 'react-redux';
import { logIn } from '../../authSlice';
import { syncLocalStorageFromSession, broadcastLogin } from '../../../../CommonMethods/authSession';
import HelpGuideModal from '../../../../components/HelpGuideModal';
import {useGetHelpGuideAdminQuery} from '../../../../features/patientSlice'


const TrustBrowser = ({setIsTrustMyBrowser}) => {
    const dispactch = useDispatch()
    const newUuid = crypto.randomUUID();
    const { setToastmessage, UpdateCall, setUpdateCall,setToastErrorMessage,isSideBar } = useContext(GlobalContext)
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [initialLoad, setInitialLoad] = useState(true)
    const number_of_days = sessionStorage.getItem('browser_trust_duration') || localStorage.getItem('browser_trust_duration')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
 
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
   
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    

    const handleTrustBrowser = async () => {
        setLoading(true)
        
        // Check if browser already has a trusted ID, reuse it for multiple users
        let browserId = localStorage.getItem('arcm_trust_browser_token')
        // "null"/"undefined" are left behind by the logout restore; trusting them would trust every browser
        if (!browserId || ['null', 'undefined'].includes(browserId)) {
            browserId = newUuid
            localStorage.setItem('arcm_trust_browser_token', browserId)
        }
        
        const body = {
            "trust_my_browser" : true,
            "browser_id" : browserId
        }
        let res
    
        res = await userService.trustMyBrowser(body);
       
        if(res.error === false) {
            // Sync tokens from sessionStorage → localStorage and broadcast to other tabs
            syncLocalStorageFromSession();
            broadcastLogin();
            dispactch(logIn())
            setLoading(false)
            setIsTrustMyBrowser(false)
            setTimeout(function() {
                // dispactch(handleSidebarAnimation(false))
                navigate('/profile')
            }, 500);
            setToastmessage('Login successful')
        } else {
            setLoading(false)
            setToastErrorMessage('Something went wrong!')
        }
    }

    const handleClickNo = () => {
        // Sync tokens from sessionStorage → localStorage and broadcast to other tabs
        syncLocalStorageFromSession();
        broadcastLogin();
        dispactch(logIn());
        setIsTrustMyBrowser(false)
        setTimeout(function() {
            // dispactch(handleSidebarAnimation(false))
            navigate('/profile')
        }, 500);
        setToastmessage("Login successful")
  
    }



    useEffect(() => {
        setTimeout(() => {
            setInitialLoad(false)
        }, 500);
    }, [])

    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-trust-browser');
        } else {
            setQueryParamsadmin('type=admin-trust-browser');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
    

    
    return (
        <>
            {initialLoad ? <CustomOverLay Active text="Loading..." classKey={`absolute z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center w-full h-full justify-center`}/> :(
                <AnimatedModel 
                    Children={
                        <div data-te-modal-init="" className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none" id="modalforDeactivate" tabIndex="-1" aria-labelledby="modalforDeactivateTitle" aria-modal="true" role="dialog" data-te-open="true" style={{display: "block"}}>
                            <div data-te-modal-dialog-ref="" className="pointer-events-none relative flex min-h-[calc(100vh-1rem)] w-auto translate-y-[-50px] translate-x-[10px] items-center opacity-1 transition-all duration-300 ease-in-out min-w-[943px] m-auto max-w-[943px] pt-[80px]">
                                <div className="pointer-events-auto flex w-full flex-col rounded-[8px] border-none bg-bg1 bg-clip-padding text-current shadow-s6 outline-none min-w-[943px] mx-auto max-w-[943px] px-[24px] pt-[24px] pb-5 relative">
                                    <img src='/images/browser-tick.svg' alt='img' className='w-[70px] h-[70px] m-auto mt-[30px]'/>
                                    <div className="flex py-[16px] ml-[280px]">
                                        <h1 className='text-2xl font-normal text-[#000]'>Do You Want to Trust This Browser?  
                                        </h1>
                                        { 
                                            userType !=="super-admin" && 
                                            <span onClick={() => setHelpGuideModel(true)} className='mt-[7px] ml-1 cursor-pointer'>
                                                <img src="/images/info.png" alt="icon" loading="lazy" decoding="async" />
                                            </span> 
                                        }
                                    </div> 
                                    <p className='px-[172px]'>If you choose to trust this browser, you will not be asked for an OTP code for the next {number_of_days} day(s) when you log in, as long as cookies are enabled.</p>
                                    <div className="w-full mb-40">
                                        <div className='flex -mx-2.5 mt-14'>
                                            <div className='ml-40 w-1/4'>
                                                <button
                                                    onClick={(e) => {handleClickNo(e)}} 
                                                    id="Cancel"
                                                    disabled={loading}
                                                    className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-lg font-semibold text-[#972E4C] w-[147px]" 
                                                > {"No, I Don't"}
                                                </button>
                                            </div>
                                            <div className='px-2.5 w-1/4'>
                                                <UpdateButton 
                                                    loading={loading} 
                                                    classKey={` ml-20 py-2.5 px-4 rounded-[16px] border border-[#972E4C]  hover:bg-[#AB556E] ${false ? 'bg-[#777C88]' : 'bg-[#972E4C]' } focus:bg-[#863B50] text-lg font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf w-[280px]`} 
                                                    ButtonName={'Yes,Trust This Browser'} 
                                                    handleOnCLick={(e)=>{handleTrustBrowser(e)}} 
                                                    disabled={loading}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                />
            )

            }
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
            }
        </>
      
        
    );
}

export default TrustBrowser;
